// ======================================================================
// File Name       : ServiceRecordMaxInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Row } from 'react-bootstrap';

class ServiceRecordMaxInfo extends React.Component {
  render() {
    const { numberId, isSupperUserL0, LMSStorage, videoStorageUsage, videoFlowRate, liveFlowRate, liveUsageTime, multiLanguageDocumentPage, isUsingNewPlan } = this.props;
    return (
      <div>
        <Col sm={3} className="padding-left-15">最大利用量</Col>
        <Col sm={9}>
          <Row className="margin-bottom-5">
            <Col sm={7}>ID数</Col>
            <Col sm={5}>
              {numberId && `${numberId} 人`}
            </Col>
          </Row>
          <Row className="margin-bottom-5">
            <Col sm={7}>LMSストレージ使用量</Col>
            <Col sm={5}>
              {LMSStorage && `${LMSStorage}`}
            </Col>
          </Row>
          <Row className="margin-bottom-5">
            <Col sm={7}>ビデオストレージ使用量</Col>
            <Col sm={5}>
              {videoStorageUsage && `${videoStorageUsage}`}
            </Col>
          </Row>
          <Row className="margin-bottom-5">
            <Col sm={7}>ビデオ流量（総量）</Col>
            <Col sm={5}>
              {videoFlowRate && `${videoFlowRate}`}
            </Col>
          </Row>
          <Row className="margin-bottom-5">
            <Col sm={7}>多言語ドキュメントページ数</Col>
            <Col sm={5}>
              {multiLanguageDocumentPage && `${multiLanguageDocumentPage}`}
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}

export default ServiceRecordMaxInfo;
